export default __webpack_public_path__ + "static/media/bsi-logo-dark.7f96c2de.svg";